export class ComponentDetailsController {

    constructor(User, $stateParams, $scope, ComponentsDao, ScanDao, EventXDao, JFrogGridFactory, JFrogModal, JFrogEventBus, $state, XRayUtils, JFrogNotifications, uiGridConstants) {
        this.rootComponentId = this.currComponentId = $stateParams.componentID;
        this.scope = $scope;
        this.componentsDao = ComponentsDao;
        this.eventXDao = EventXDao;
        this.scanDao = ScanDao;
        this.jfrogGridFactory = JFrogGridFactory;
        this.modal = JFrogModal;
        this.$state = $state;
        this.user = User;
        this.xrayUtils = XRayUtils;
        this.jFrogNotifications = JFrogNotifications;
        this.uiGridConstants = uiGridConstants;

        this.details = [];
        this.treeDir = $stateParams.treeDir || 'desc';
        this.rootComponentName = this.currComponentName = this.xrayUtils.getComponentPrettyName(this.rootComponentId);

        this._createFilesGrid();
        this._createVersionsGrid();
        this._createIssuesGrid();
        this._createLicenseGrid();
        this.getDetails();
        this.getRootData();

        this.EVENTS = JFrogEventBus.getEventsDefinition();
        JFrogEventBus.registerOnScope($scope, this.EVENTS.COMPONENT_SELECT, this.onComponentChange.bind(this));
        this.JFrogEventBus = JFrogEventBus;
    }

    getComponentIcon() {
        return this.xrayUtils.getComponentIcon(this.currComponentType);
    }

    onComponentChange(nextComponent) {
        this.currComponentId = nextComponent.component_id;
        this.currComponentType = nextComponent.pkg_type;
        this.currNode = nextComponent;
        this.currComponentName = this.xrayUtils.getComponentPrettyName(this.currComponentId);

        this.getDetails();
    }

    getDetails() {
        this.componentsDao.getDetails({}, {
            component_id: this.currComponentId
        }).$promise.then((details) => {
//            details.map((detailsPanel) => this._createGridOptions(detailsPanel))
            this.details = details;
            if (this.details.general) this.details.general = this.xrayUtils.getCapitalizedKeys(this.details.general);
            this.filesGridOptions.setGridData(details.files);
            if (details.versions) {


                let sortedVersions = _.sortBy(details.versions, 'version_number');
                //console.log(this.test.reverse());
                this.versionsGridOptions.setGridData(sortedVersions.reverse());
            }
            if (details.issues) this.issuesGridOptions.setGridData(details.issues);
            if (details.licenses) this.licenseGridOptions.setGridData(details.licenses);
        })
    }

    getRootData() {
        this.componentsDao.getData({}, {
            component_id: this.rootComponentId
        }).$promise.then((data) => {
            this.rootIsScannable = data.is_root;
            this.rootComponentType = this.currComponentType = data.pkg_type;
        })
    }

    /*
     _createGridOptions(detailPanel) {
     if (detailPanel.displayType === 'grid') {
     detailPanel.gridOptions = this._createGrid(detailPanel.items)
     }

     return detailPanel;
     }

     _createGrid(data = [{}]) {
     return this.jfrogGridFactory.getGridInstance(this.scope)
     .setRowTemplate('default')
     .setColumns(this._getDynamicColumns(Object.keys(data[0])))
     .setGridData(data);
     }
     */

    _createFilesGrid() {
        this.filesGridOptions = this.jfrogGridFactory.getGridInstance(this.scope)
            .setRowTemplate('default')
            .setColumns(this._getFilesGridColumn());
    }

    _createVersionsGrid() {
        this.versionsGridOptions = this.jfrogGridFactory.getGridInstance(this.scope)
            .setRowTemplate('default')
            .setColumns(this._getVersionsGridColumn());
    }

    _createIssuesGrid() {
        this.issuesGridOptions = this.jfrogGridFactory.getGridInstance(this.scope)
            .setRowTemplate('default')
            .setColumns(this._getIssuesGridColumn())
            .setButtons(this._getIssuesActions())

    }

    _createLicenseGrid() {
        this.licenseGridOptions = this.jfrogGridFactory.getGridInstance(this.scope)
            .setRowTemplate('default')
            .setColumns(this._getLicenseGridColumn())


    }

    /*
     _getDynamicColumns(keys = []) {
     return keys.map((column) => ({
     name: column,
     displayName: column,
     field: column
     }));
     }
     */


    _getFilesGridColumn() {
        return [
            {
                name: 'Name',
                displayName: 'Name',
                field: "name",
                width: '20%'
            },
            {
                name: 'Path',
                displayName: 'Path',
                cellTemplate: '<div ng-if="row.entity.url" class="ui-grid-cell-contents"><a ng-href="{{row.entity.url}}" target="_blank">{{row.entity.path}}</a></div>' +
                '<div ng-if="!row.entity.url" class="ui-grid-cell-contents">{{row.entity.path}}</div>',
                field: "path",
                width: '60%'
            },
            {
                name: 'Added',
                displayName: 'Added',
                cellTemplate: `<div ng-if="row.entity.added" class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.added | date:'medium'}}</div><div  class="ui-grid-cell-contents" ng-if="!row.entity.added" >N/A</div>`,
                field: "added",
                width: '10%'
            },
            {
                name: 'Info',
                displayName: 'Info',
                field: "dummy",
                cellTemplate: '<div class="ui-grid-cell-contents grid-icon"><i class="icon icon-info" jf-tooltip="SHA-256: {{row.entity.sha256}}"></i></div>',
                width: '10%'
            }
        ]
    }

    _getVersionsGridColumn() {
        return [
            {
                name: 'Version Number',
                displayName: 'Version Number',
                field: "version_number",
                sortingAlgorithm: (a, b) => this.xrayUtils.semverCompare(a, b),
                width: '50%'
            },
            {
                name: 'Released',
                displayName: 'Released',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.released | date:'medium'}}</div>`,
                field: "released",
                width: '50%'
            }
        ]
    }

    _getIssuesGridColumn() {
        return [
            {
                name: 'Summary',
                displayName: 'Summary',
                field: "summary",
                cellTemplate: '<div ng-if="row.entity.provider === \'Custom\'" class="ui-grid-cell-contents" ng-click="grid.appScope.ComponentDetails.editIssue(row.entity)"><a href>{{row.entity.summary}}</a></div>' +
                '<div ng-if="row.entity.provider !== \'Custom\'" class="ui-grid-cell-contents">{{row.entity.summary}}</div>',
                width: '40%'
            },
            {
                name: 'Severity',
                displayName: 'Severity',
                field: "severity",
                width: '15%'
            },
            {
                name: 'Issue Type',
                displayName: 'Issue Type',
                field: "issue_type",
                width: '15%'
            },
            {
                name: 'Component',
                displayName: 'Component',
                field: "component",
                width: '30%'
            }
            /*
             {
             name: 'Type',
             displayName: 'Info',
             field: "dummy",
             cellTemplate: '<div class="ui-grid-cell-contents grid-icon"><i class="icon icon-info" jf-tooltip="Issue Type: {{row.entity.issue_type}}<br/>Timestamp: [MISSING]"></i></div>',
             width: '10%'
             }
             */
        ]
    }

    _getLicenseGridColumn() {
        return [
            {
                name: 'Name',
                displayName: 'Name',
                field: "name",
                width: '40%'
            },
            {
                name: 'details',
                displayName: 'More info',
                field: "more_info[0]",
                width: '60%'
            }]
    }


    _getActions() {
        return {
            'seeRelatedComponents': {title: 'View Component Details', icon: 'icon-view'},
            'manualScan': {title: 'Scan for Issues', icon: 'icon-xray-scanning'},
            'assignCustomIssue': {title: 'Assign Custom Issue', icon: 'icon-xray-impact-analysis'}
        }
    }

    initActions(actionsController) {
        actionsController.setActionsDictionary(this._getActions());

        actionsController.setActions([
            {
                name: 'seeRelatedComponents',
                visibleWhen: () => this.currComponentId !== this.rootComponentId,
                action: () => this.seeRelatedComponents()
            },
            {
                name: 'manualScan',
                visibleWhen: () => this.currComponentId !== this.rootComponentId ? this.currNode && this.currNode.is_root : this.rootIsScannable,
                action: () => this.manualScan()
            },
            {
                name: 'assignCustomIssue',
                visibleWhen: () => true,
                action: () => this.assignCustomIssue()
            }
        ]);
    }


    setTreeDir(dir) {
        this.$state.go('components.details', {componentID: this.rootComponentId, treeDir: dir});
    }

    seeRelatedComponents(componentID) {
        this.$state.go('components.details', {componentID: componentID || this.currComponentId, treeDir: this.treeDir});
    }

    manualScan(componentID) {
        this.scanDao.startScan({componentID: componentID || this.currComponentId}).$promise.then((result) => {
            if (result.info
            )
                this.jFrogNotifications.create({info: 'Manual Scan Started'});
        });
    }

    assignCustomIssue(componentID) {
        const assignCustomIssueModal = this.scope.$new();
        assignCustomIssueModal.componentId = componentID || this.currComponentId;
        this.modal.launchModal('assign_custom_issue_modal', assignCustomIssueModal).result.then(() => {
            this.getDetails();
        })
    }

    showTreeSearch() {
        this.JFrogEventBus.dispatch(this.EVENTS.ACTIVATE_TREE_SEARCH);
    }

    _getIssuesActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete Issue',
                callback: (row) => this.deleteIssue(row),
                visibleWhen: (row) => {
                    return this.user.getCurrent().admin && row.provider.toLowerCase() === 'custom'
                }

            }

        ];
    }

    deleteIssue(issue) {
        this.modal.confirm('Are you sure you want to delete this issue ?')
            .then(() => {
                this.eventXDao.deleteIssue({}, {vulnerabilityID: issue.id}).$promise.then(() => {
                    this.getDetails();
                })
            });
    }

    editIssue(issue) {
//        console.log('editIssue: ' + issue.id);
        const assignCustomIssueModal = this.scope.$new();
        assignCustomIssueModal.issueId = issue.id;
        this.modal.launchModal('assign_custom_issue_modal', assignCustomIssueModal).result.then(() => {
            this.getDetails();
        })
    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/components/component_details.controller.js